// Switching company replaces the session server-side: requestChangePassportCom creates a
// new session, and CreateSession terminates the user's existing ones for this client first
// (single session policy). Requests that race that swap come back session_invalid even
// though the user is perfectly signed in, which would otherwise pop the "Session Expired"
// re-authentication dialog. While a swap is in progress those responses are ignored.
//
// Kept in its own module so both the axios interceptor and the auth store can use it
// without importing each other.
let swapDepth = 0

export const beginSessionSwap = () => {
    swapDepth++
}

export const endSessionSwap = () => {
    swapDepth = Math.max(0, swapDepth - 1)
}

export const isSessionSwapping = () => swapDepth > 0
